import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const AdmittedTodayBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-warning text-white">
      {t('component:badge.admittedToday')}
    </Badge>
  );
};
